import { type FC } from "react";
import * as styles from "./styles.css";

export const Header: FC = () => (
  <header className={styles.header}>
    <img
      className={styles.logo}
      src="/images/user_frontend/global/rejob_service_logo.svg"
      alt="リジョブのロゴ"
    />
  </header>
);
